
import useLazySelector from "common/redux/useLazySelector";
import PhysicalLocation from "domain/physicalLocation";
import { loadLocations } from "./locations.action";
import useStoreSelector from "common/redux/useStoreSelector";
import useTraders from "features/settings/traders/useTraders";

const defaultVal: PhysicalLocation[] = [];
export default function useLocations(): PhysicalLocation[] {
    return useLazySelector(m => m.locations, dispatch => loadLocations()(dispatch), null, defaultVal);
}

export function useAllowedLocations(): PhysicalLocation[] {
    const traders = useTraders();
    const myId = useStoreSelector(m => m.userState.internalId);
    const myTrader = traders.data.find(m => m.userId === myId);
    const locations = useLocations();

    if (myTrader == null) return locations;

    return locations.filter(l => myTrader.locations.some(tl => tl.id === l.id));
}